<template>
  <div class="p-col-12 p-d-flex p-jc-between p-ai-center">
    <!-- :disabled="lesson.meeting_active === 0" -->
    <Button
      label="Unirse a la Sesión"
      class="p-button-raised"
      @click="goVideoConference()"
    />
    <Checkbox
      class="p-ml-4"
      v-model="checks"
      :value="
        checks.find((e) => e.lesson_id === lesson.id) || {
          lesson_id: lesson.id,
        }
      "
      :disabled="true"
    />
  </div>
</template>

<script>
import checkService from "@/services/axios/check.service";
export default {
  props: {
    lesson: {
      type: Object,
      required: true,
    },
    lessons_check: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      checks: [],
    };
  },
  mounted() {
    this.checks = [...this.lessons_check];
  },
  methods: {
    toogleLessonCheck() {
      const status = this.checks.some((e) => e.lesson_id === this.lesson.id);
      if (!status) {
        this.createLessonCheck();
      }
    },
    createLessonCheck() {
      checkService
        .createLessonCheck({
          lesson_id: this.lesson.id,
        })
        .then(({ data }) => {
          this.checks = data;
        });
    },
    deleteLessonCheck() {
      checkService.deleteLessonCheck(this.lesson.id).then(({ data }) => {
        this.checks = data;
      });
    },
    goVideoConference() {
      let route = this.$router.resolve({ name: "LessonMeet" });
      window.open(route.href);
      this.toogleLessonCheck();
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Leccion/StudenLessonMeeting.vue